import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types'
import { getData } from './../../../services/db'


export class Features extends Component {
  state = {
    features: null,
    modal: false,
    feature: null,
  }


  toggle = (feature) => {
    this.setState({
      modal: !this.state.modal,
      feature
    })
  }

  getFeatures = async () => {
    const { route } = this.props

    const wizardId = route.location.pathname.split('/')[1]

    const wizardURL = `http://yoo.devletec.info/wp-json/yoo/v1/wizard/${wizardId}`

    const wizardData = await getData(wizardURL)

    if (wizardData) {
      this.setState({
        features: wizardData.features
      })
    }
  }

  componentDidMount() {
    this.getFeatures()
  }

  render() {
    const { features, modal, feature } = this.state

    return (
      <div data-test="FeaturesComponent" className="features-wizard">
        <div className="row mg-left-0 mg-right-0 around-xs start-md">
          {features && features.map((feature, index) => {
            return (
              <div className="" key={feature.title + index}>
                <button className="button--transparent btn-opacity" onClick={() => this.toggle(feature)}>{feature.title}</button>
              </div>
            )
          })}
          {feature &&
            <Modal isOpen={modal} toggle={this.toggle}>
              <ModalHeader toggle={this.toggle}>{feature.title}</ModalHeader>
              <ModalBody>
                <div dangerouslySetInnerHTML={{ __html: feature.description }} />
              </ModalBody>
              <ModalFooter>
                <button onClick={this.toggle}>OK</button>
              </ModalFooter>
            </Modal>
          }
        </div>
      </div>
    )
  }
}

Features.propTypes = {
  route: PropTypes.object
}

export default Features
